
const logLevels = {
  info: 30,
  warn: 40,
  error: 50,
  fatal: 60,
};

// Used when making requests, to kick off the log trace for a given request. This should be the first log in the
// log trace for a given request in New Relic
const infoLogRequest = ({ method, requestUrl, requestId, sessionId }) =>
  fetch("/log", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      level: 30,
      app: window.location.pathname.split("avt-")[1]
        ? window.location.pathname.split("avt-")[1].split("/")[0]
        : window.location.pathname,
      method,
      page: window.location.pathname,
      requestId,
      sessionId,
      url: requestUrl,
      userEmail: AVT.user?.email,
    }),
  });

// Used for when a request fails but the application can still function, and there should be a ERROR log upstream
// in the logtrace from whatever service endpoint failed
const warningLogRequest = ({ requestUrl, requestId, sessionId, message }) =>
  fetch("/log", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      level: 40,
      app: window.location.pathname.split("avt-")[1]
        ? window.location.pathname.split("avt-")[1].split("/")[0]
        : window.location.pathname,
      message,
      page: window.location.pathname,
      requestId,
      sessionId,
      url: requestUrl,
      userEmail: AVT.user?.email,
    }),
  });

// Used for decoder errors or any other Front end related errors where there would be no upstream error logged
const errorLogRequest = ({ requestUrl, requestId, sessionId }) =>
  fetch("/log", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      level: 50,
      app: window.location.pathname.split("avt-")[1]
        ? window.location.pathname.split("avt-")[1].split("/")[0]
        : window.location.pathname,
      page: window.location.pathname,
      requestId,
      sessionId,
      url: requestUrl,
      userEmail: AVT.user?.email,
    }),
  });

// Used for when a request fails and the application cannot function
const fatalLogRequest = ({ requestUrl, requestId, sessionId, message }) =>
  fetch("/log", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      level: 60,
      app: window.location.pathname.split("avt-")[1]
        ? window.location.pathname.split("avt-")[1].split("/")[0]
        : window.location.pathname,
      message,
      page: window.location.pathname,
      requestId,
      sessionId,
      url: requestUrl,
      userEmail: AVT.user?.email,
    }),
  });

// ========================
// Manual Logging Functions
// ========================

const log = ({ message, ...otherFields }, level) => {
  const body = JSON.stringify({
    level,
    app: window.location.pathname.split("avt-")[1]
      ? window.location.pathname.split("avt-")[1].split("/")[0]
      : window.location.pathname,
    message,
    page: window.location.pathname,
    sessionId: localStorage.getItem("sessionId"),
    additionalData: otherFields,
  });
  console.log(`Logging: ${body}`);
  fetch("/log", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  });
};

const info = (logObject) => {
  log(logObject, logLevels.info);
};

const warn = (logObject) => {
  log(logObject, logLevels.warn);
};

const error = (logObject) => {
  log(logObject, logLevels.error);
};

const fatal = (logObject) => {
  log(logObject, logLevels.fatal);
};

export {
  infoLogRequest,
  warningLogRequest,
  errorLogRequest,
  fatalLogRequest,
  info,
  warn,
  error,
  fatal,
};
